import { render, staticRenderFns } from "./MigrationDate.vue?vue&type=template&id=70d67ba6"
import script from "./MigrationDate.vue?vue&type=script&lang=js"
export * from "./MigrationDate.vue?vue&type=script&lang=js"
import style0 from "./MigrationDate.vue?vue&type=style&index=0&id=70d67ba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports